/*
 * File: RequestedShipDateRangeSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 13 Dec 2021 7:47:02 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { DatePicker, Space } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterEndDate, setFilterStartDate } from 'redux/salesOrder/ordersSlice';
import { FancyDateRangePicker } from '../FancyDateRangePicker';

const styles: InlineStylesModel = {
  titleColor: {
    // color: '#2F5596'
  }
};

const { RangePicker } = DatePicker;

export const RequestedShipDateRangeSearch: FC = () => {
  const [rangeValues, _setRangeValues] = useState<string[]>([]);
  const dispatch = useDispatch();

  const handleChange = (_date: unknown, dateStrings: [string, string]): void => {
    if (dateStrings[0] !== '' && dateStrings[1] !== '') {
      dispatch(setFilterStartDate(dateStrings[0]));
      dispatch(setFilterEndDate(dateStrings[1]));
    } else {
      dispatch(setFilterEndDate(undefined));
      dispatch(setFilterStartDate(undefined));
    }
  };
  const handleCalendarChange = (_dates: unknown, dateStrings: [string, string], info: { range: unknown | unknown }): void => {
    if (dateStrings[0] !== '' && dateStrings[1] !== '') {
      dispatch(setFilterStartDate(dateStrings[0]));
      dispatch(setFilterEndDate(dateStrings[1]));
    } else {
      dispatch(setFilterEndDate(undefined));
      dispatch(setFilterStartDate(undefined));
    }
  };

  return (
    <Space direction="vertical" size="small">
      <FancyDateRangePicker rangeValues={rangeValues} placeHolder={'Requested Ship Date'} onInputChange={handleChange} onCalendarChange={handleCalendarChange} format="yyyy-MM-DD" width={250} />
    </Space>
  );
};
